import { scrollable } from '../../mixins';
import { createStyles } from '../withStyles';
const styles = (theme) => createStyles({
    root: {
        width: '100%',
    },
    items: Object.assign({ 
        // A magic number so we partially show the 3rd item to indicate that
        // the user can scroll.
        maxHeight: 212, minHeight: 104, boxSizing: 'border-box', padding: theme.spacing(1), display: 'flex', flexDirection: 'column' }, scrollable()),
    disabled: {
        overflow: 'hidden',
    },
    contentWrapper: {
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.borderRadius.lg,
        boxShadow: `0px 3px 9px ${theme.palette.divider}`,
        '&$withSearch': {
            paddingTop: theme.spacing(1),
        },
    },
    withSearch: {},
});
export default styles;
//# sourceMappingURL=MultiSelectField.styles.js.map